import EmailVerification from '@/components/Auth/EmailVerification'

const EmailVerificationScreen = () => {
  return <EmailVerification />
}

export default EmailVerificationScreen
